var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_+") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-460.000000, -2310.000000)",
    fill: "#00cfff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467,2310 C463.133885,2310 460,2313.13388 460,2317 C460,2320.86612 463.133885,2324 467,2324 C470.866115,2324 474,2320.86612 474,2317 C474,2313.13388 470.866115,2310 467,2310 Z M470.819177,2317.63679 L467.63679,2317.63679 L467.63679,2320.81918 C467.63679,2321.17121 467.352034,2321.45597 467,2321.45597 C466.647966,2321.45597 466.36321,2321.17121 466.36321,2320.81918 L466.36321,2317.63679 L463.182387,2317.63679 C462.830353,2317.63679 462.545597,2317.35203 462.545597,2317 C462.545597,2316.64797 462.830353,2316.36321 463.182387,2316.36321 L466.364774,2316.36321 L466.364774,2313.18239 C466.364774,2312.83035 466.649531,2312.5456 467.001565,2312.5456 C467.353599,2312.5456 467.638355,2312.83035 467.638355,2313.18239 L467.638355,2316.36477 L470.820742,2316.36477 C471.172776,2316.36477 471.457532,2316.64953 471.457532,2317.00156 C471.455968,2317.35203 471.169647,2317.63679 470.819177,2317.63679 Z",
    id: "ic_+"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon_+.a8fd2a21b732a1cd695b52a5068ab3fb.svg";
export { ForwardRef as ReactComponent };